


import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateStudentModal = ({ onClose, student, classData }) => {
  const [className, setClassName] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [classId, setClassId] = useState(classData.id);
  const [loading, setLoading] = useState(false);
  const [pass, setPass] = useState('');
  
  useEffect(() => {
    if (classData) setClassName(classData.class_name || "");
  }, [classData]);

  useEffect(() => {
    if (student) {
      setClassName(student.class_name || "");
      setRollNo(student.roll_no || "");
      setName(student.name || "");
      setEmail(student.email || "");
      setPhone(student.phone || "");
      setPass(student.password || "");
    }
  }, [student]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const studentData = {
      class_name: student ? className : classId,
      roll_no: rollNo,
      name,
      email,
      phone,
    };

    try {
      if (student) {
      const result =   await axios.put(`https://api.scannscore.com/student/${student.id}`, studentData);
       
          if (result.status === 200) {
                 toast.success("Student updated successfully", { toastId: "update-student" });
        
                setTimeout(() => {
                    onClose();
                }, 2000);
              }
      } else {
        const response = await axios.post("https://api.scannscore.com/student", studentData);


            toast.success(
        response.data.message || "Student added successfully",
        { toastId: "add-student" }
      );

      setTimeout(() => {
        onClose();
      }, 2000);


      }

  
    } catch (error) {

      if(error.status == 400){
toast.error("Student exists with same Enrollment number", { toastId: "error-student" });
      } else {      
      // console.error("Error saving student:", error.status);
      toast.error("Failed to save student", { toastId: "error-student" });}
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.3)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: "30px",
            width: "420px",
            maxWidth: "90%",
      maxHeight: "90vh",
      overflowY: "auto",  
        scrollbarWidth: "none",  
    msOverflowStyle: "none",
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
          }}
          className="hide-scrollbar"
        >
          <div style={{ textAlign: "right" }}>
            <button
              onClick={onClose}
              style={{ border: "none", background: "transparent", fontSize: "22px", cursor: "pointer" }}
            >
              ✕
            </button>
          </div>

          <h3 style={{ marginBottom: "20px", fontWeight: "600" }}>
            {student ? "Edit Student" : "Add Student"}
          </h3>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "15px" }}>
              <label>Class Name</label>
              <input type="text" value={className} placeholder="Class Name" style={inputStyle} disabled />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label>Roll No</label>
              <input type="text" value={rollNo} placeholder="Roll No" onChange={(e) => setRollNo(e.target.value)} required style={inputStyle} />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label>Name</label>
              <input type="text" value={name} placeholder="Name" onChange={(e) => setName(e.target.value)} style={inputStyle} />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label>Email</label>
              <input type="email" value={email} placeholder="Email Id" onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label>Phone</label>
              <input type="tel" value={phone} maxLength={10} placeholder="Phone No" onChange={(e) => setPhone(e.target.value)} style={inputStyle} required />
            </div>

{student &&
            <div style={{ marginBottom: "20px" }}>
              <label>Password</label>
              <input type="text" value={pass} placeholder="Password" style={inputStyle}  disabled />
            </div>
}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "10px",
                background: "#192B80",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              {loading ? "Saving..." : student ? "Update Student" : "Save Student"}
            </button>
          </form>
        </div>
      </div>

    <ToastContainer
              position="top-center"
              autoClose={2000}
              theme="colored"
            />
    </>
  );
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginTop: "5px",
  border: "1px solid #ccc",
  borderRadius: "0",
  outline: "none",
};

export default CreateStudentModal;